import styled from '@emotion/styled';

export const InputLabelContainer = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.palette?.brand.secondary.base};
  font-weight: 600;
`;
